<script lang="ts">
    import InView from "./InView.svelte"
    import MedialibImage from "./MedialibImage.svelte"
    import ProductConfiguratorCustomAttributes from "./ProductConfiguratorCustomAttributes.svelte"

    export let product: ProductEntry

    export let productConfig: ArticleConfig = {
        article: product.externalData,
        customAttributes: {},
        valid: true,
    }

    // use first configuration as default
    export let bomItemConfigs: ArticleConfig[] =
        product?.externalData?.bomItems.map((bomItem) => {
            return {
                article: bomItem.validArticles[0],
                customAttributes: {},
                valid: true,
            }
        }) || []

    export let quantity: number = 1

    // object binding fires twice becourse of the way svelte handles object binding
    // $: console.log(articleConfigs)
</script>

{#if product.externalData.customAttributes?.length}
    <div class="col-12 col-md-auto">
        <div class="product-configurator-wrapper">
            <div class="grid bom-row unrelative align-start vp-m">
                <div class="col-sm-3 unrelative">
                    <div class="thumbnail">
                        <figure>
                            <InView>
                                <MedialibImage id="{product.teaserimage}" />
                            </InView>
                        </figure>
                    </div>
                </div>
                <div class="col-12 col-md-auto product-info">
                    <div class="grid">
                        <div class="col-12">
                            <div class="product-info">
                                <a href="/products/{product?.slug || product?.id}">
                                    <span class="product-title h3">{product?.title}</span>
                                </a>
                                <div class="badge">
                                    {#if product?.number}
                                        <span>Art.-No. {product?.number}</span>
                                    {/if}
                                </div>
                            </div>
                        </div>
                        <ProductConfiguratorCustomAttributes bind:articleConfig="{productConfig}" {quantity} />
                    </div>
                </div>
            </div>
        </div>
    </div>
{/if}

{#if product.externalData.bomItems?.length || product.externalData.properties?.sportidentIdRangeMax}
    <div class="col-12 col-md-auto">
        <div class="product-configurator-wrapper">
            {#each product?.externalData?.bomItems || [] as bomItem, idx}
                <div class="grid bom-row unrelative align-start vp-m">
                    <div class="col-sm-3 unrelative">
                        {#if bomItemConfigs[idx]?.article?.properties?.tipProductOptionFileName || bomItemConfigs[idx]?.article?.properties?.bodyProductOptionFileName || bomItemConfigs[idx]?.article?.properties?.strapProductOptionFileName}
                            <div class="thumbnail" data-element="{bomItemConfigs[idx]?.article?.properties?.cardType}">
                                {#each ["tip", "body", "strap"] as part}
                                    {#if bomItemConfigs[idx]?.article?.properties?.[part + "ProductOptionFileName"]}
                                        <div
                                            class="bom-image-wrapper {part}"
                                            data-cardtype="{bomItemConfigs[idx]?.article?.properties?.cardType}"
                                            data-strap="{bomItemConfigs[idx]?.article?.properties
                                                ?.strapProductOptionName}"
                                            data-article="{product?.externalData?.name}"
                                        >
                                            <img
                                                src="https://www.sportident.com/p/assets/images/{bomItemConfigs[idx]
                                                    ?.article?.properties?.[part + 'ProductOptionFileName']}"
                                                alt="{bomItemConfigs[idx]?.article?.properties?.[
                                                    part + 'ProductOptionName'
                                                ]}"
                                                class="bom-image {part}"
                                            />
                                        </div>
                                    {/if}
                                {/each}
                            </div>
                        {/if}
                    </div>
                    <div class="col-12 col-md-auto product-info">
                        <div class="grid">
                            <div class="col-12">
                                <div class="product-info">
                                    <a href="/products/{product?.slug || product?.id}">
                                        <span class="product-title h3">{product?.title}</span>
                                    </a>
                                    <div class="badge">
                                        {#if product?.number}
                                            <span>Art.-No. {product?.number}</span>
                                        {/if}
                                    </div>
                                </div>
                                <div class="form">
                                    <div class="grid align-center">
                                        <div class="col-3 col-md-2">
                                            <span class="gray-bg quantity border-radius-all border-radius-s"
                                                >{bomItem.orderItem?.quantity || 1} x</span
                                            >
                                        </div>
                                        {#if bomItem.validArticles?.length > 1}
                                            <div class="col-grid col-12 col-md-auto border-bottom">
                                                <select
                                                    on:change="{(e) => {
                                                        bomItemConfigs[idx] = {
                                                            ...bomItemConfigs[idx],
                                                            // @ts-ignore
                                                            article: bomItem.validArticles.find(
                                                                // @ts-ignore
                                                                (article) => article.articleNumber === e.target.value
                                                            ),
                                                        }
                                                    }}"
                                                >
                                                    {#each bomItem.validArticles || [] as article}
                                                        <option
                                                            value="{article.articleNumber}"
                                                            selected="{article.articleNumber ===
                                                                bomItemConfigs[idx]?.article.articleNumber}"
                                                            >{article.name}
                                                            <!--
                                                            {article.properties?.bodyProductOptionName || ""}
                                                            {article.properties?.tipProductOptionName || ""}--></option
                                                        >
                                                    {/each}
                                                </select>
                                            </div>
                                        {:else}
                                            <!-- quantity space for non-quantity items -->
                                            <div class="col-grid col-auto">
                                                {bomItem.orderItem?.articleName || ""}
                                            </div>
                                        {/if}
                                    </div>
                                </div>
                            </div>

                            <ProductConfiguratorCustomAttributes
                                bind:articleConfig="{bomItemConfigs[idx]}"
                                quantity="{quantity * (bomItem.orderItem?.quantity || 1)}"
                                excludedCustomAttributes="{bomItem?.excludedCustomAttributes}"
                                initialConfiguration="{bomItem?.orderItem?.configuration}"
                            />
                        </div>
                    </div>
                    <!-- <pre>{JSON.stringify(bomItem, null, 4)}</pre> -->
                </div>
            {/each}
        </div>
    </div>
{/if}
